import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ReactComponent as UnauthorizedIcon } from '../assets/unauthorized.svg'

export default function Unauthorized() {
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(5);

  useEffect(() => {
    const interval = setInterval(() => {
      setCountdown((sec) => sec - 1);
    }, 1000);

    const timeout = setTimeout(() => {
      navigate("/");
    }, 5000);

    return () => {
      clearInterval(interval);
      clearTimeout(timeout);
    };
  }, [navigate]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-100 px-6">
      <div className="text-center">
        <UnauthorizedIcon className={`w-20 h-20 mx-auto mb-4`}/>

        <h1 className="text-2xl font-semibold text-gray-800 mb-2">
          Access Denied
        </h1>

        <p className="text-gray-600 mb-4">
          You do not have permission to view this page.
        </p>

        <p className="text-gray-500 text-sm">
          Redirecting in{" "}
          <span className="font-semibold">{countdown}</span> seconds •{" "}
          <span
            onClick={() => navigate("/")}
            className="text-blue-600 hover:underline cursor-pointer"
          >
            Go now
          </span>
        </p>
      </div>
    </div>
  );
}